import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

export const isHomeOn = (home: boolean, adminDate: string) =>
  Boolean(home || adminDate);

export const hasHome: Permission = () =>
  isHomeOn(getFlag(FlagType.Home), getFlag(FlagType.HomeAdminSettings));
